import { appAxios } from '@/../axios/axios';
import { endpoints } from '@/../config/endpoints';
import { Cookies } from '@/interfaces/Cookies';

export class AjaxService {

    public static get(url: string, token = '') {
        return new Promise((resolve, reject) => {
            appAxios({
                url,
                baseURL: endpoints.rest,
                method: 'GET',
                headers: token.length > 0 ? {Authorization: `Bearer ${token}`} : null,
            }).then((response) => {
                resolve(response.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    public static post(url: string, params: unknown, token = '') {
        let headers: any = {};
        if (token.length > 0) {
            // @ts-ignore
            headers.Authorization = `Bearer ${token}`;
        }

        if (Object.keys(headers).length <= 0) {
            headers = null;
        }

        return new Promise((resolve, reject) => {
            appAxios({
                url,
                baseURL: endpoints.rest,
                data: params,
                method: 'POST',
                headers,
            }).then((response) => {
                resolve(response.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    public static delete(url: string, token = '') {
        return new Promise((resolve, reject) => {
            appAxios({
                url,
                baseURL: endpoints.rest,
                method: 'DELETE',
                headers: token.length > 0 ? {Authorization: `Bearer ${token}`} : null,
            }).then((response) => {
                resolve(response.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    public static patch(url: string, params: unknown, token = '') {
        return new Promise((resolve, reject) => {
            appAxios({
                url,
                baseURL: endpoints.rest,
                data: params,
                method: 'PATCH',
                headers: token.length > 0 ? {Authorization: `Bearer ${token}`} : null,
            }).then((response) => {
                resolve(response.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    public static setToken(token: string) {
        appAxios.defaults.headers.common.Authorization = `Bearer ${token}`;
    }

    public static unsetToken() {
        delete appAxios.defaults.headers.common.Authorization;
    }
}
